'use client';

import ErrorPage from '@components/ErrorPage/ErrorPage';
import * as Sentry from '@sentry/nextjs';
import {useTranslations} from 'next-intl';
import {useEffect} from 'react';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & {digest?: string};
    reset: () => void;
}) {
    const t = useTranslations('error500');

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    const reload = () => {
        reset();
    };

    return (
        <html>
            <body>
                <ErrorPage
                    body={t('body')}
                    title="000"
                    buttonLabel={t('button')}
                    buttonIcon="refresh"
                    onClick={reload}
                    error={error}
                />
            </body>
        </html>
    );
}
